import { Controller } from "./Controller";
import { ControllerRegistry } from "../Registry/ControllerRegistry";

export class ResultListController extends Controller {

}

ControllerRegistry.register("ResultListController", ResultListController);
